import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Building from "./assets/Building.svg";

const HeroSection = () => {
  const words = ["Precision", "Passion"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="w-full min-h-[600px] flex flex-col md:flex-row items-center justify-between px-4 sm:px-6 md:px-12 lg:px-20 xl:px-24 2xl:px-32 py-12 sm:py-14 md:py-16 bg-white font-Epilogue">
      
      <div className="w-full md:w-1/2 flex flex-col justify-center items-start text-left mb-10 md:mb-0">
        <span className="text-gray-800 font-semibold tracking-widest text-xs sm:text-sm mb-4 sm:mb-6 uppercase">
          Construction
        </span>
        
        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-5xl xl:text-5xl font-bold text-[#1a1a1b] leading-[1.1] mb-6 sm:mb-8">
          Building the Future <br />
          <span className="flex items-baseline flex-wrap">
            with&nbsp;
            <span className="relative inline-flex overflow-hidden h-[1.2em] leading-[1.1]">
              <span className="invisible pointer-events-none whitespace-nowrap">
                {words[index]}
              </span>

              <AnimatePresence mode="wait">
                <motion.span
                  key={words[index]}
                  className="absolute left-0 text-[#10893E] whitespace-nowrap"
                  initial={{ y: "-100%", opacity: 0 }}
                  animate={{ y: "0%", opacity: 1 }}
                  exit={{ y: "100%", opacity: 0 }}
                  transition={{ 
                    duration: 0.5, 
                    ease: [0.23, 1, 0.32, 1]
                  }}
                >
                  {words[index]}
                </motion.span>
              </AnimatePresence>
            </span>
          </span>
        </h1>

        <p className="text-gray-600 text-base sm:text-lg md:text-lg max-w-full sm:max-w-lg md:max-w-2xl leading-relaxed">
          From residential to commercial, we deliver quality construction 
          solutions that stand the test of time.
        </p>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center">
        <img 
          src={Building} 
          alt="Building" 
          className="w-full max-w-[280px] sm:max-w-sm md:max-w-md lg:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl h-auto object-contain"
        />
      </div>
      
    </section>
  );
};

export default HeroSection;